"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Bookmark24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "bookmark-24", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M17.0097656,4.01656168 L7,4.00275962 L7,18.4195183 L11.9992643,15.3114673 L17.0097656,18.4221647 L17.0097656,4.01656168 Z M19.0097656,2.01931749 L19.0097656,21.478563 C19.0097656,21.6442484 18.875451,21.778563 18.7097656,21.778563 C18.6538456,21.778563 18.5990387,21.7629335 18.5515299,21.7334383 L12,17.6660156 L5.45839495,21.7329424 C5.3176858,21.8204216 5.13270266,21.7772701 5.04522355,21.6365609 C5.01566509,21.5890165 5,21.5341497 5,21.478166 L5,2 L19.0097656,2.01931749 Z", id: "Path-12", fill: "#000000", fillRule: "nonzero" })));
}
function Bookmark24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Bookmark24Svg, Object.assign({}, svgProps)));
}
exports.default = Bookmark24;
//# sourceMappingURL=Bookmark24.js.map